export default __webpack_public_path__ + "static/media/icon-balance.3f957c77.svg";